import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import { AuthLoginInfo } from "../AuthComponents/AuthLogin";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function DiscountPage() {
  const [discountData, setDiscountData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [newDiscountSubmitted, setNewDiscountSubmitted] = useState(false);
  const [discountDetails, setDiscountDetails] = useState({
    pointMark: "",
    discountValue: 0,
    isPercent: false,
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterDiscounts, setFilterDiscounts] = useState("");

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalDiscounts = filteredData.length;
  const computedDiscounts = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );
const formatToCurrency = (number) => {
    return number.toLocaleString('vi-VN');
};

const addNewDiscount = () => {
    const token = localStorage.getItem('token');
    axios
      .post(
        `${config.apiEndpoint}/Discount`,
        {
          pointMark: discountDetails.pointMark,
          discountValue: discountDetails.discountValue,
          isPercent: discountDetails.isPercent,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setDiscountDetails({
            pointMark: "",
            discountValue: 0,
            isPercent: true,
          });
          console.log("New discount added successfully");
          setButtonNewPopup(false);
          setNewDiscountSubmitted(!newDiscountSubmitted); // Toggle to trigger useEffect
        }
      })
      .catch((err) => {
        console.error("Error adding new discount:", err);
      });
  };


const updateDiscount = () => {
    const token = localStorage.getItem('token');
    console.log('discountData :', discountDetails);
 
    axios.put(
        `${config.apiEndpoint}/Discount/${discountDetails.id}`,
        {
            id : discountDetails.id,
            pointMark : discountDetails.pointMark,
            discountValue :discountDetails.discountValue,
            isPercent: discountDetails.isPercent,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
    )
    .then((res) => {
        if (res.status === 204) {   
            setNewDiscountSubmitted(!newDiscountSubmitted); // Toggle to trigger useEffect
            setButtonShowPopup(false);
            console.log("Discount updated successfully");
        }
    })
    .catch((err) => {
        console.error("Error updating discount:", err);
    });
};


  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/Discount`, { headers: { Authorization: `Bearer ${token}` }, withCredentials: true })
      .then(res => {
        console.log('discountData', res.data);
        setDiscountData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching discounts:", err);
      });
  }, [newDiscountSubmitted]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Discount Manager</h1>
          <Pagination
            total={totalDiscounts}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterDiscounts("");
                    setFilterActive(1);
                  }}
                >
                  All discounts
                </li>
               
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={discountData}
                handleSearchChange={handleSearchChange}
                dataType="discount"
                status={filterDiscounts}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>Discount ID</th>
                  <th>Mark</th>
                  <th>Discount Value</th>
                  <th>Is Percent</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedDiscounts.map((discount) => {
                    return (
                    <tr key={discount.id}>
                      <td>
                      <font className="maincolor">#</font>
                      {discount.id}
                      </td>
                      <td>{formatToCurrency(discount.pointMark)} {""}</td>
                      <td>{formatToCurrency(discount.discountValue)} {discount.isPercent?" %":" vnđ"}</td>
                      <td>{discount.isPercent ? "Yes" : "No"}</td>
                      <td className="maincolor">
                      <button
                        className=""
                        style={{ marginRight: "20px" }}
                        onClick={() => {
                        const token = localStorage.getItem('token');
                        axios
                          .delete(`${config.apiEndpoint}/discount/${discount.id}`, {
                          headers: { Authorization: `Bearer ${token}` },
                          withCredentials: true,
                          })
                          .then((res) => {
                          if (res.status === 204) {
                            setNewDiscountSubmitted(!newDiscountSubmitted); // Toggle to trigger useEffect
                            console.log("Discount removed successfully");
                          }
                          })
                          .catch((err) => {
                          console.error("Error removing discount:", err);
                          });
                        }}
                      >
                        <RemoveRoundedIcon />
                      </button>
                      <button
                        className=""
                        onClick={() => {
                        setButtonShowPopup(true);
                        setSelectedDiscount(discountData.indexOf(discount));
                        setDiscountDetails(discount)
                        console.log('selectedDiscount', selectedDiscount);
                        console.log('setDiscountDetails', discount);

                        }}
                      >
                        <ReadMoreRoundedIcon />
                      </button>
                      </td>
                    </tr>
                    );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new Discount</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="number"
                    placeholder="Point Mark"
                    className="orderDetailsInput"
                    value={discountDetails.pointMark}
                    onChange={(e) =>
                      setDiscountDetails({
                        ...discountDetails,
                        pointMark: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="number"
                    placeholder="Discount Value"
                    className="orderDetailsInput"
                    value={discountDetails.discountValue}
                    onChange={(e) =>
                      setDiscountDetails({
                        ...discountDetails,
                        discountValue: Number(e.target.value),
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="checkbox"
                    checked={discountDetails.isPercent}
                    onChange={(e) =>
                      setDiscountDetails({
                        ...discountDetails,
                        isPercent: e.target.checked,
                      })
                    }
                  />
                  <label>Is Percent</label>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewDiscount()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
      <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit Discount</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                {true && (
                  <div className="input-group">
                    <input
                        type="number"
                        placeholder="Mark"
                        className="orderDetailsInput"
                        value={discountDetails.pointMark}
                        onChange={(e) =>
                        setDiscountDetails({
                            ...discountDetails,
                            pointMark: e.target.value,
                        })
                        }
                        required="required"
                    />
                </div>
                )}  

                {true && (
                  <div className="input-group">
                    <input
                        type="number"
                        placeholder="Discount Value"
                        className="orderDetailsInput"
                        value={discountDetails.discountValue}
                        onChange={(e) =>
                        setDiscountDetails({
                            ...discountDetails,
                            discountValue: e.target.value,
                        })
                        }
                        required="required"
                    />
                </div>
                )} 
              </div>

              <div className="productSummaryRight newUserSwitch" style={{ width: "100%", marginTop: "20px" }}> 
                <h3>Is Percent </h3>
                <input
                  type="radio"
                  name="rdo"
                  id="yes"
                  onChange={() => {
                    console.log('discountDetails 1', discountDetails);
                    setDiscountDetails({
                        ...discountDetails,
                        isPercent: true,
                      })
                  }}
                  defaultChecked="defaultChecked"
                />
                <input
                  type="radio"
                  name="rdo"
                  id="no"
                  onChange={() => {
                    console.log('discountDetails 2', discountDetails);
                    setDiscountDetails({
                        ...discountDetails,
                        isPercent: false,
                      })
                  }}              
                />
                <div className="switch">
                  <label className="switchLabel" htmlFor="yes">
                    Yes
                  </label>
                  <label className="switchLabel" htmlFor="no">
                    No
                  </label>  
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => {
                    updateDiscount();
                }}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default DiscountPage;